import { authorizedFetch } from '../../helpers/authorizedFetch'
import { formatDate } from '../../helpers/date'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import getIncluded from '../../japi/getIncluded'
import isResourceCollectionDocument from '../../japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '../../japi/types/Document'
import { DateFormat } from '../../types/dateFormatTypes'
import { FetchCollectionResult, FetchResultType } from '../FetchResult'
import { UserResource } from '../User/User'
import { ShiftsCalendarAbsence, ShiftsCalendarAbsenceResource } from './ShiftsCalendarAbsence'
import { transformToShiftsCalendarAbsence } from './ShiftsCalendarAbsenceTransformers'

export const getShiftsCalendarAbsencesIndexCall = async (
    startDate: Date,
    endDate: Date,
): Promise<FetchCollectionResult<ShiftsCalendarAbsence[], string>> => {
    try {
        const url = generateApiUrl({
            endpoint: '/absences',
            queryParams: {
                include: 'user',
                startDate: formatDate(startDate, DateFormat.apiDateTime),
                endDate: formatDate(endDate, DateFormat.apiDateTime),
            },
        })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<ShiftsCalendarAbsenceResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const shiftsCalendarAbsences = doc.data.map(shiftsCalendarAbsenceResource => {
            const userResource = getIncluded(doc, shiftsCalendarAbsenceResource, 'user') as UserResource

            return transformToShiftsCalendarAbsence(
                shiftsCalendarAbsenceResource,
                userResource,
            )
        })

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: shiftsCalendarAbsences,
        }
    } catch (error) {
        console.error('[getShiftsCalendarAbsencesIndexCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
